import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { ChromiumSnackbar } from '@chancenwerk/client/design/components/cr-snackbar.js';
import { WorkshopAPI } from '@chancenwerk/shared/workshops/api/WorkshopAPI.js';
import { Workshop } from '@chancenwerk/shared/workshops/entities/Workshop.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { DateTime } from 'luxon';
import { switchMap } from 'rxjs';

/**
 * @customElement akademie-component-workshop-registration
 */
@customElement('akademie-component-workshop-registration')
export class AkademieComponentWorkshopRegistration extends ChemistryLitElement {
  @property() workshopID = new RXController(this, '');

  @state() _workshop = new RXController(
    this,
    this.workshopID.observable.pipe(
      switchMap(id =>
        Workshop.subscribeByID<Workshop>(id ?? '')({
          ...Workshop.allFields,
          appointments: {
            start: 1,
          },
        }),
      ),
    ),
  );

  override render() {
    return html` <cr-flex space="md" padding="lg">
      <cr-h1 ${css({ marginBottom: this.spacing.lg })}>Anmeldung: ${this._workshop.value?.title}</cr-h1>
      <chancen-component-card-title>Beschreibung</chancen-component-card-title>
      <cr-text>${unsafeHTML(this._workshop.value?.description ?? '')}</cr-text>
      <chancen-component-card-title>Termine</chancen-component-card-title>
      <cr-text>Wähle einen Termin aus, um dich für den Workshop anzumelden:</cr-text>
      <cr-grid columns="1fr 1fr 1fr" space="md">
        ${repeat(
          (this._workshop.value?.appointments ?? []).filter(
            appointment => (appointment.start ?? DateTime.now()).diffNow().milliseconds > 0,
          ),
          appointment => appointment._id,
          appointment =>
            html`<cr-card
              space="sm"
              href="#"
              @click=${async () => {
                if (!(await ChromiumDialog.confirm('Möchtest du dich wirklich für diesen Termin anmelden?'))) {
                  return;
                }

                const res = await ChromiumDialog.waitFor<boolean>(
                  WorkshopAPI.createRegistration(appointment._id ?? '')(),
                  'Anmeldung wird erstellt...',
                );

                if (res) {
                  ChromiumSnackbar.show('Anmeldung erfolgreich erstellt');
                  this.dispatchEvent(new CustomEvent('success'));
                }
              }}
            >
              <cr-text>Termin</cr-text>
              <cr-text bold>${appointment.start?.toFormat('dd.MM.yyyy HH:mm')}</cr-text>
            </cr-card>`,
        )}
      </cr-grid>
    </cr-flex>`;
  }
}
